var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 9.99982C19.9996 15.5226 15.5226 19.9996 9.99982 19.9996C4.47707 19.9996 0 15.5226 0 9.99982C0 4.47707 4.47707 0 9.99982 0C15.5226 0 19.9996 4.47707 19.9996 9.99982ZM1.57599 9.99982C1.57599 14.6545 5.34518 18.4237 9.99982 18.4237C14.6545 18.4237 18.4237 14.6545 18.4237 9.99982C18.4237 5.34518 14.6545 1.57599 9.99982 1.57599C5.34518 1.57599 1.57599 5.34518 1.57599 9.99982Z",
    fill: "white",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99994 1.000358C11.8905 1.000358 13.7424 1.53629 15.3407 2.54602C16.939 3.55575 18.2184 4.99789 19.0304 6.70519C19.8424 8.4125 20.1538 10.315 19.9285 12.1921C19.7031 14.0692 18.9503 15.844 17.7572 17.3106L16.8102 16.4469C17.9345 15.0648 18.644 13.3924 18.8564 11.6234C19.0687 9.8545 18.7753 8.06161 18.0101 6.45268C17.2448 4.84375 16.0392 3.48471 14.5329 2.53317C13.0267 1.58163 11.2816 1.076572 9.49994 1.076572V1.000358Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.807ac0bbbe13226542ed4db4ab9b1a80.svg";
export { ForwardRef as ReactComponent };